import { useEffect, useState, type FormEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../auth'
import { Button } from '../components/Button'
import { Input } from '../components/Input'
import { useToast } from '../components/Toast'
import { ApiError } from '../api'

export function LoginPage() {
  const { login, user } = useAuth()
  const navigate = useNavigate()
  const toast = useToast()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (user) navigate('/', { replace: true })
  }, [user, navigate])

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await login(username.trim(), password)
    } catch (e) {
      if (e instanceof ApiError && (e.status === 401 || e.status === 400)) {
        setError("Couldn't sign you in — check username and password.")
      } else if (e instanceof ApiError) {
        setError(`Sign-in failed (HTTP ${e.status}). Try again, or ask the Owner to check the server.`)
      } else {
        setError('Sign-in failed. Check the server and your network connection.')
      }
    } finally {
      setBusy(false)
    }
  }

  function onForgotPassword() {
    toast.show('Ask the Owner to reset your password.', 'info')
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit} noValidate>
        <div className="login-mark">macmini</div>
        <h1>Sign in</h1>
        <p className="login-sub">Use the account the Owner created for you.</p>

        <Input
          label="Username"
          name="username"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          disabled={busy}
          required
        />
        <Input
          label="Password"
          name="password"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={busy}
          required
        />

        {error && <div className="login-error">{error}</div>}

        <Button type="submit" variant="primary" block disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </Button>

        <button
          type="button"
          className="login-link"
          onClick={onForgotPassword}
        >
          Forgot password?
        </button>
      </form>
    </div>
  )
}
